/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { TextSendMessageRequestType } from "./TextSendMessageRequestType";

export interface TextSendMessageRequest {
  type?: TextSendMessageRequestType;
  content: string;
  height_in?: number | null;
  weight_lb?: number | null;
}
